<template>
  <div>
    <div>
      <div class="agreement-container">
        <h2 class="title">e农平台竞标规则</h2>
        <p style="float: right">生效日期：2023年03月15日</p>
        <p>&nbsp;</p>
        <p class="p-text">《e农平台竞标规则》（以下简称“本协议”）是由e农网站（即www.e-nongye.com.cn或e农根据业务需要不时修改的包括但不限于计算机或移动设备互联网的URL）及客户端、e农APP及e农微信商城（以下简称“e农平台”）的运营方即华农农服（北京）网络科技有限公司（以下简称”e农”）。</p>
        <p class="p-text">在此特别提醒您认真阅读本协议各条款，并请您审慎考虑并选择接受或不接受本协议。为您通过e农平台标售功能达成交易，请充分阅读、理解并自愿接受本协议，同意受本协议各项条款的约束。</p>
        <p class="bold">1. e农平台标售规则与规则定义</p>
        <p>1）“标售总量”为全量标售，竞标中报价最高者中标（如果报价一致，则按照时间先后顺序，优先者中标），仅可一人中标。</p>
        <p>2）小于或等于限定的“可报价总量”为分量标售，按照报价时间先后顺序原则中标，仅可一人中标。</p>
        <p>3）小于或等于限定的”可报价总量“为分量标售，按照报价时间先后顺序原则中标，可多人中标，规则为总中标量不超过”标售总量“。</p>
        <p>4）竞标发布人可自定义编辑标售规则，包括是否限制参与人、是否限制买家竞价次数、竞标最小参与人数等。</p>
        <p>5）是否限制参与人：标售期间可参与用户，可公开竞价/定向竞价。</p>
        <p>6）是否限制买家竞价次数：标售期间买家出价次数，如果限制，可设置限制次数。</p>
        <p>7）最少参与人数：标售参与报价的最少人数，如果少于此人数，本场则为流拍；如果限制，可设置限制次数：竞买人须在标售开始时间前登录e农平台并选择标售报名，报名成功后，可参与该标售场次。</p>
        <p>8）标售日期：标售开始日期。</p>
        <p>9）开始时间：标售活动开始时间。</p>
        <p>10）结束时间：标售活动结束时间。</p>
        <p>11）标售总量：本次标售的总数量。</p>
        <p>12）起拍价：物品起购价。</p>
        <p>13）加价梯度：单次最小加价幅度。</p>
        <p>14）起拍量：本次标售买家最低起购量。</p>
        <p>15）单用户限量：每个参与标售买家最多购买数量。</p>
        <p>16）加量梯度：单次最小加量幅度。</p>
        <p>17）价格条款：物品所执行的价格条款。</p>
        <p>18）付款类型：余额支付。</p>
        <p>19）交货时间：中标客户交完全款后在交货时间前提完全部货物。</p>
        <p>20）运输方式：汽运、铁运、船运或其他。支持多种运输方式请选择其他，其它可补充说明。</p>
        <p>21）限制最高价：竞买人出价不得超过此价格。</p>
        <p class="bold">2. 标售流程</p>
        <p>1）发布标售信息：竞卖人应提前发布标售信息，包括标售规则、标售商品、最高限价、是否需要竞买人缴纳保证金等。</p>
        <p>2）标售成功后，并于平台确认交易达成。结算完成后e农平台将解除冻结保证金并退还到竞买人余额。</p>
        <p class="bold">3. 标售责任限制</p>
        <p>1）<span class="p-text">用户应遵守《e农服务协议》交易规则以及e农平台发布的其他规则及流程，并遵守法律规定。</span></p>
        <p>2）<span class="p-text">成交后，竞买人应于标售成功后在规定时间内将标售成交价货款以余额支付的方式支付给竞卖人。竞买人逾期未支付全部成交价款的，视为违约，保证金将不予返还，且竟买人应承担全部损失。</span></p>
        <p>3）<span class="p-text">e农平台有权对非法标售，非正常标售进行管理，取消相关场次中标结果。</span></p>
        <p>4）<span class="p-text">标售信息一旦发布不许修改，竞卖人有权暂停标售，产生损失由竞卖人全部承担。</span></p>
        <p>5）<span class="p-text">标的物以实物现状为准，e农平台不承担标售标的质量保证。请竞买人认真查看实际情况。</span></p>
        <p>6）<span class="p-text">在标售期间，竞买人不得阻挠其他竞买人竞价，不得与其他竟买人相互串通，恶意压价等，一经发现，竟卖人有权拒绝其参加标售或取消其买受人资格，并追究相关法律责任。</span></p>
        <p>7）<span class="p-text">竞买人付款后应及时提取标的物，逾期不办理的，买受人应支付由此产生的费用，并承担本标的物可能发生的损毁、灭失等后果；同时，卖受人应在收到对应货款后第一时间履行货物交割。</span></p>
        <p>8）<span class="p-text">标售活动计价货币为人民币，标售时的起拍价、成交价均不含买受人在标售标的物交割、运输时所发生的全部费用。买受人自行至标的物存放地点提货，标的物在交付过程中因整理、装卸、运输等产生的费用和安全责任，以及经营风险由买受人自负自理。e农平台不做任何担保，不承担买卖双方交易过程中的任何责任。</span></p>
        <p>9）<span class="p-text">因不确定因素或不可抗力致使标售标的物不能如期交割等一切事宜，e农平台不承担相关责任。</span></p>
        <p>10）<span class="p-text">e农平台有权在标售开始前作出暂缓标售或撤回标售的决定，e农平台不向竞买人承担任何责任及一切费用。</span></p>
        <p class="bold">4. 其他</p>
        <p>1）竞买人因参与标售与e农平台发生纠纷的，双方协商解决，协商不成时，任何一方均可直接向人民法院起诉。</p>
        <p>2）e农平台有权根据标售业务需要对本协议进行修订，并以网站公告的形式进行更新。经修订的协议一经在e农平台公布，即默认信息已送达，双方已知晓，对双方都具有法律约束力。如竞买人不同意相关修订，请竞买人立即停止使用所有标售服务。如竞买人继续使用标售服务的，则将视为竞买人已接受经本协议的修订，当竞买人与e农平台发生争议时，应以最新的标售协议条款为准。</p>
        <p>3）<span class="p-text">敬请注意，e农平台不能控制或保证物品的质量、安全或合法性，以及相关交易各方履行在贸易协议项下的各项义务的能力。e农平台不能也不会控制交易各方能否履行协议义务。此外。您应注意到，欺诈交易的风险是客观存在的，希望您在使用e农平台的服务时，小心谨慎并仔细核实。</span></p>
        <p>4）未尽事宜，各方应友好协商解决。e农平台在法律许可范围内享有最终解释权。</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    closeEvent(){
      window.opener=null;
      window.close();
    }
  }
}
</script>

<style lang="scss">

.agreement-container{
  margin-top: 21px;
  border: 1px #e4e4e4 solid;
  background: #fff;
  padding: 0 40px 0 40px;
  p{
    line-height: 30px;
    font-size:14px;
    color:#666;
    word-break: break-all;
  }
  h2{
    padding:60px 0 40px;
    text-align: center;
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight: 700;
    font-size: 20px;
  }
  .bold{
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight:700;
    color:#1ABC9C;
    line-height: 76px;
  }

  .p-text {
    text-decoration:underline;
    font-size:14px;
    font-weight:bold;
  }
  .p-t {
    font-size:14px;
    font-weight:bold;
  }

  .p-n {
    text-decoration:underline;
  }
}
.link{
  cursor: pointer;
  .fa-close{
    margin-right: 5px;
    font-size: 16px;
    color: #1ABC9C;
  }
}
</style>
